const PIX_SERVER_PAYLOAD_ENUM = {
  key: 'pix_server',
  value: 'Stone'
}

const SIMULATOR_PAYLOAD_ENUM = {
  key: 'simulator',
  value: 'Simulator'
}

const PAGARME_PAYLOAD_ENUM = {
  key: 'pagarme',
  value: 'PSP'
}

const MUNDIPAGG_PAYLOAD_ENUM = {
  key: 'mundipagg',
  value: 'Gateway'
}

export {
  PIX_SERVER_PAYLOAD_ENUM,
  SIMULATOR_PAYLOAD_ENUM,
  PAGARME_PAYLOAD_ENUM,
  MUNDIPAGG_PAYLOAD_ENUM
}
